/**
 * iPhone / iPad (в том числе iPadOS, который представляется Mac'ом) — у
 * WebKit на iOS свои правила звука: открытый микрофон переключает
 * аудиосессию и глушит воспроизведение, а `play()` вне жеста блокируется.
 */
export function isIOS(): boolean {
  if (typeof navigator === 'undefined') return false;
  if (/iP(hone|ad|od)/.test(navigator.userAgent)) return true;
  return navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1;
}
